import React, { useState } from "react";
import {
    Box,
    CardMedia,
    Typography,
    IconButton,
    Grid,
    Container,
    Tooltip,
} from "@mui/material";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { Card, CardContainer } from "./Card";

const FollowersSlider = ({
    data,
    containerTitle = "Significant Followers",
    maxNameLength = 15, // Configurable truncation length
}) => {
    const [startIndex, setStartIndex] = useState(0);
    const itemsToShow = 5;

    const handleNext = () => {
        if (startIndex + itemsToShow < data.length) {
            setStartIndex((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (startIndex > 0) {
            setStartIndex((prev) => prev - 1);
        }
    };

    const formatFollowers = (count) => {
        return (count / 10000).toFixed(2) + "L";
    };

    const handleProfileClick = (url) => {
        window.open(url, "_blank");
    };

    const truncateName = (name) => {
        if (name.length <= maxNameLength) {
            return name;
        }
        return name.substring(0, maxNameLength) + "...";
    };

    return (
        <Box className="no-export">
            <CardContainer>
                <Card>
                    <Container maxWidth="lg" sx={{ margin: "-20px" }}>
                        <Box sx={{ position: "relative", py: 4 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    variant="highlightSemibold"
                                    component="h2"
                                >
                                    {containerTitle}
                                </Typography>
                                <Box>
                                    <IconButton
                                        onClick={handlePrev}
                                        disabled={startIndex === 0}
                                    >
                                        <ArrowCircleLeftOutlinedIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={handleNext}
                                        disabled={
                                            startIndex + itemsToShow >=
                                            data.length
                                        }
                                    >
                                        <ArrowCircleRightOutlinedIcon />
                                    </IconButton>
                                </Box>
                            </Box>

                            <Grid container spacing={2}>
                                {data
                                    .slice(startIndex, startIndex + itemsToShow)
                                    .map((item) => (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={2.4}
                                            key={item.id}
                                        >
                                            <Box
                                                onClick={() =>
                                                    handleProfileClick(item.url)
                                                }
                                                sx={{
                                                    cursor: "pointer",
                                                    "&:hover": {
                                                        opacity: 0.9,
                                                        transform:
                                                            "scale(1.02)",
                                                        transition:
                                                            "all 0.2s ease-in-out",
                                                    },
                                                }}
                                            >
                                                <CardMedia
                                                    component="img"
                                                    image={item.image_url}
                                                    alt={item.username}
                                                    sx={{
                                                        height: 200,
                                                        objectFit: "cover",
                                                        borderRadius: 2,
                                                    }}
                                                />
                                                <Box sx={{ py: 1.5 }}>
                                                    <Tooltip
                                                        title={item.username}
                                                        arrow
                                                        placement="top"
                                                    >
                                                        <Typography
                                                            variant="contentRegular"
                                                            sx={{
                                                                fontWeight:
                                                                    "bold",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            {truncateName(
                                                                item.username
                                                            )}
                                                        </Typography>
                                                    </Tooltip>
                                                    <br />
                                                    <Typography
                                                        variant="supportRegular"
                                                        color="text.secondary"
                                                    >
                                                        {formatFollowers(
                                                            item.followers
                                                        )}{" "}
                                                        Followers
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                            </Grid>
                        </Box>
                    </Container>
                </Card>
            </CardContainer>
        </Box>
    );
};

export default FollowersSlider;
